import { render, staticRenderFns } from "./FAQForm.vue?vue&type=template&id=affad112&"
import script from "./FAQForm.vue?vue&type=script&lang=js&"
export * from "./FAQForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports